<template>
  <div class="pb-5">
    <div class="content">
      <div class="row align-items-center">
        <div class="col-md-6">
          <Titulo
            title="Meus espaços"
            description="Lista das reservas solicitadas no CDL Varejo Inteligente"
          />
        </div>
        <div class="col-md-6 text-left text-md-right mt-3 mt-md-0">
          <Botao
            title="Nova Locação"
            link="/produto/cdl-varejo-inteligente/produtos"
            nameClass="btn btn-warning font-weight-bold px-4"
            >NOVA LOCAÇÃO</Botao
          >
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="loading">
      <loading />
    </div>
    <ListaVarejo class="mt-5" :lista="lista" v-else-if="lista.length > 0" />
    <div class="col-12" v-else>
      <div
        class="border-0 py-5 d-flex justify-content-center align-items-center"
      >
        <h5>Nenhuma reserva encontrada. 😟</h5>
      </div>
    </div>
    <div class="py-5"></div>
  </div>
</template>
<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import ListaVarejo from "@/components/agenda/ListaVarejo";

export default {
  name: "Lista",
  components: { Titulo, Botao, ListaVarejo },
  data() {
    return {
      produto: {
        nome: "CDL Varejo Inteligente",
        id: "CdlVarejo",
      },
      breadcrumb: [
        {
          nome: "CDL Varejo Inteligente",
          id: "CDL Varejo Inteligente",
          link: "/produto/cdl-varejo-inteligente/produtos",
        },
        {
          nome: "Painel de Reservas",
          id: "painel_reservas",
          produto: "CDL Varejo Inteligente",
        },
      ],
      lista: [],
      loading: true,
    };
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    sessionStorage.removeItem("reserva");

    this.$http
      .get("/api/Agenda/ConsultarMinhaAgenda")
      .then((response) => {
        if(response.data.length === 0){
          this.loading = false;
          return false;
        }
        var r = response.data;
        r.forEach((r) => {
          const inicio = new Date(r.inicio);
          const fim = new Date(r.fim);
          var tipoEvento = "Evento";
          var intervalo = "";
          if (r.estacoes && r.estacoes.length) {
            tipoEvento = "Estações";
            var evento = "";
            r.estacoes.forEach((e) => {
              if (evento) {
                evento += ", " + e.posicao;
              } else {
                evento += e.posicao;
              }
            });
          }

          if (
            r.espaco === "ESCRITÓRIO VIRTUAL" ||
            r.espaco === "ESTAÇÃO DE TRABALHO"
          ) {
            intervalo =
              ("0" + inicio.getDate()).slice(-2) +
              "/" +
              ("0" + (inicio.getMonth() + 1)).slice(-2) +
              "/" +
              inicio.getFullYear() +
              " - " +
              ("0" + fim.getDate()).slice(-2) +
              "/" +
              ("0" + (fim.getMonth() + 1)).slice(-2) +
              "/" +
              fim.getFullYear();
          }

          if (r.espaco === "ESCRITÓRIO VIRTUAL") {
            tipoEvento = "Estações";
            evento = "-";
          }

          if (r.espaco === "ROOFTOP" || r.espaco.match(/SALA/)) {
            tipoEvento = "Evento";
            evento = r.nomeEvento;
            intervalo =
              ("0" + inicio.getDate()).slice(-2) +
              "/" +
              ("0" + (inicio.getMonth() + 1)).slice(-2) +
              "/" +
              inicio.getFullYear() +
              " • " +
              ("0" + inicio.getHours()).slice(-2) +
              ":" +
              ("0" + inicio.getMinutes()).slice(-2) +
              " - " +
              ("0" + fim.getHours()).slice(-2) +
              ":" +
              ("0" + fim.getMinutes()).slice(-2);
          }

          var dadosLista = {
            espaco: r.espaco,
            tipoEvento: tipoEvento,
            evento: evento,
            responsavel: r.responsavel,
            intervalo: intervalo,
          };

          this.lista.push(dadosLista);
        });
        this.loading = false;
      })
      .catch((error) => {
        if (error.statusCode === 401) {
          this.$router.push({ name: "login" });
        }
      });
  },
};
</script>
